export const repoData = {
    owner: "ruitang2create",
    repo: "gatsby_portfolio",
}